export default "__VITE_ASSET__4ocmme1m__"